// @ts-ignore
var _0xodi = 'jsjiami.com.v7';
((function (
  _0x4a23a8,
  _0x1be0e1,
  _0x8dc6ff,
  _0x321bce,
  _0x1d5098,
  _0x5ac504,
  _0xd571c2,
) {
  return (
    (_0x4a23a8 = _0x4a23a8 >> 0x8),
    (_0x5ac504 = 'hs'),
    (_0xd571c2 = 'hs'),
    (function (_0x4e74e3, _0xe411, _0x1ba407, _0x785ebf, _0x242ed1) {
      var _0xd84cac = _0x2f78;
      ((_0x785ebf = 'tfi'),
        (_0x5ac504 = _0x785ebf + _0x5ac504),
        (_0x242ed1 = 'up'),
        (_0xd571c2 += _0x242ed1),
        (_0x5ac504 = _0x1ba407(_0x5ac504)),
        (_0xd571c2 = _0x1ba407(_0xd571c2)),
        (_0x1ba407 = 0x0));
      var _0x19a2ed = _0x4e74e3();
      while (!![] && --_0x321bce + _0xe411) {
        try {
          _0x785ebf =
            (-parseInt(_0xd84cac(0xc9, 'lVj1')) / 0x1) *
              (parseInt(_0xd84cac(0xc7, 'jQQK')) / 0x2) +
            -parseInt(_0xd84cac(0xce, '(^nH')) / 0x3 +
            (parseInt(_0xd84cac(0xd0, 'eXBu')) / 0x4) *
              (-parseInt(_0xd84cac(0xc2, '&&eQ')) / 0x5) +
            (-parseInt(_0xd84cac(0xbd, 'z3Ln')) / 0x6) *
              (parseInt(_0xd84cac(0xd1, 'Kliy')) / 0x7) +
            parseInt(_0xd84cac(0xbe, 'lVj1')) / 0x8 +
            -parseInt(_0xd84cac(0xc3, 'jQQK')) / 0x9 +
            (-parseInt(_0xd84cac(0xcd, 'FSPR')) / 0xa) *
              (-parseInt(_0xd84cac(0xc8, 'WYbx')) / 0xb);
        } catch (_0x114a38) {
          _0x785ebf = _0x1ba407;
        } finally {
          _0x242ed1 = _0x19a2ed[_0x5ac504]();
          if (_0x4a23a8 <= _0x321bce)
            _0x1ba407
              ? _0x1d5098
                ? (_0x785ebf = _0x242ed1)
                : (_0x1d5098 = _0x242ed1)
              : (_0x1ba407 = _0x242ed1);
          else {
            if (
              _0x1ba407 ==
              _0x1d5098['replace'](/[eTDXMGwELROVJPxfkyIrdN=]/g, '')
            ) {
              if (_0x785ebf === _0xe411) {
                _0x19a2ed['un' + _0x5ac504](_0x242ed1);
                break;
              }
              _0x19a2ed[_0xd571c2](_0x242ed1);
            }
          }
        }
      }
    })(
      _0x8dc6ff,
      _0x1be0e1,
      function (
        _0x17b107,
        _0x2867c1,
        _0x57a831,
        _0x1d5400,
        _0x3610d1,
        _0x2a5571,
        _0xda6ff,
      ) {
        return (
          (_0x2867c1 = '\x73\x70\x6c\x69\x74'),
          (_0x17b107 = arguments[0x0]),
          (_0x17b107 = _0x17b107[_0x2867c1]('')),
          (_0x57a831 = '\x72\x65\x76\x65\x72\x73\x65'),
          (_0x17b107 = _0x17b107[_0x57a831]('\x76')),
          (_0x1d5400 = '\x6a\x6f\x69\x6e'),
          (0x16b7e5, _0x17b107[_0x1d5400](''))
        );
      },
    )
  );
})(0xbf00, 0x926cc, _0x5625, 0xc1),
_0x5625) && (_0xodi = `\x591`);
function _0x2f78(_0x1deed5, _0x49eeee) {
  var _0x562576 = _0x5625();
  return (
    (_0x2f78 = function (_0x2f78db, _0x47859a) {
      _0x2f78db = _0x2f78db - 0xbd;
      var _0x8be04f = _0x562576[_0x2f78db];
      if (_0x2f78['GpXIUS'] === undefined) {
        var _0x10daae = function (_0x5eccac) {
          var _0x411da4 =
            'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';
          var _0x236e2b = '',
            _0x25e4b6 = '';
          for (
            var _0x5c8441 = 0x0, _0x2dbd36, _0x21366f, _0x3098b7 = 0x0;
            (_0x21366f = _0x5eccac['charAt'](_0x3098b7++));
            ~_0x21366f &&
            ((_0x2dbd36 =
              _0x5c8441 % 0x4 ? _0x2dbd36 * 0x40 + _0x21366f : _0x21366f),
            _0x5c8441++ % 0x4)
              ? (_0x236e2b += String['fromCharCode'](
                  0xff & (_0x2dbd36 >> ((-0x2 * _0x5c8441) & 0x6)),
                ))
              : 0x0
          ) {
            _0x21366f = _0x411da4['indexOf'](_0x21366f);
          }
          for (
            var _0x3ad5ef = 0x0, _0x3dcf5c = _0x236e2b['length'];
            _0x3ad5ef < _0x3dcf5c;
            _0x3ad5ef++
          ) {
            _0x25e4b6 +=
              '%' +
              ('00' + _0x236e2b['charCodeAt'](_0x3ad5ef)['toString'](0x10))[
                'slice'
              ](-0x2);
          }
          return decodeURIComponent(_0x25e4b6);
        };
        var _0x5cf9b0 = function (_0x5ae95b, _0x58eae9) {
          var _0x128a82 = [],
            _0xd1d5cc = 0x0,
            _0x1889ac,
            _0x3b5ffc = '';
          _0x5ae95b = _0x10daae(_0x5ae95b);
          var _0x35fdf0;
          for (_0x35fdf0 = 0x0; _0x35fdf0 < 0x100; _0x35fdf0++) {
            _0x128a82[_0x35fdf0] = _0x35fdf0;
          }
          for (_0x35fdf0 = 0x0; _0x35fdf0 < 0x100; _0x35fdf0++) {
            ((_0xd1d5cc =
              (_0xd1d5cc +
                _0x128a82[_0x35fdf0] +
                _0x58eae9['charCodeAt'](_0x35fdf0 % _0x58eae9['length'])) %
              0x100),
              (_0x1889ac = _0x128a82[_0x35fdf0]),
              (_0x128a82[_0x35fdf0] = _0x128a82[_0xd1d5cc]),
              (_0x128a82[_0xd1d5cc] = _0x1889ac));
          }
          ((_0x35fdf0 = 0x0), (_0xd1d5cc = 0x0));
          for (
            var _0x545e28 = 0x0;
            _0x545e28 < _0x5ae95b['length'];
            _0x545e28++
          ) {
            ((_0x35fdf0 = (_0x35fdf0 + 0x1) % 0x100),
              (_0xd1d5cc = (_0xd1d5cc + _0x128a82[_0x35fdf0]) % 0x100),
              (_0x1889ac = _0x128a82[_0x35fdf0]),
              (_0x128a82[_0x35fdf0] = _0x128a82[_0xd1d5cc]),
              (_0x128a82[_0xd1d5cc] = _0x1889ac),
              (_0x3b5ffc += String['fromCharCode'](
                _0x5ae95b['charCodeAt'](_0x545e28) ^
                  _0x128a82[
                    (_0x128a82[_0x35fdf0] + _0x128a82[_0xd1d5cc]) % 0x100
                  ],
              )));
          }
          return _0x3b5ffc;
        };
        ((_0x2f78['WsoMdF'] = _0x5cf9b0),
          (_0x1deed5 = arguments),
          (_0x2f78['GpXIUS'] = !![]));
      }
      var _0x4249ad = _0x562576[0x0],
        _0x15d5e3 = _0x2f78db + _0x4249ad,
        _0x54edad = _0x1deed5[_0x15d5e3];
      return (
        !_0x54edad
          ? (_0x2f78['iynbHV'] === undefined && (_0x2f78['iynbHV'] = !![]),
            (_0x8be04f = _0x2f78['WsoMdF'](_0x8be04f, _0x47859a)),
            (_0x1deed5[_0x15d5e3] = _0x8be04f))
          : (_0x8be04f = _0x54edad),
        _0x8be04f
      );
    }),
    _0x2f78(_0x1deed5, _0x49eeee)
  );
}
function _0x5625() {
  var _0x2243ba = (function () {
    return [
      _0xodi,
      'TMjyysJNjXiamiGV.dcomE.vd7RkexfxrkPIDOLw==',
      'gLtcHCoqWOZcTdRdPmk+xNPs',
      'W5acWQlcHq1DWPvWgCkjWRvc',
      'WPjlgM/cJ8kIxMBcQW',
      'WPmrgeKZW65QWQmLeCoXW7tdNG',
      'WOq1rJ0uC8oBWObYW6lcKtua',
      'WOtcJCkvaGGdna',
      'ASktW6SkW5iLmCkIa8kBW7iuW7a',
    ].concat(
      (function () {
        return [
          'WOWJCSkAWQtcS8khfSoae8kcm8oi',
          'WPmqhu44W6HTWO4vcmo7W5xdQG',
          'WR5FWONcN8oZAmoGbXvYa8ov',
          'WRtcM8onhaxcJCoVW6icWPtcMCok',
          'WOexqWTFrgNdPtldS3LxAW',
          'W4ddISkFBXPdWO87W5S',
          'WOtdQSoVqvfEmSkYW6RdH8oiWOW',
          'WQ8uzSo0W4OwWO7cRCk2W6OKxSkz',
          'WOPNnxCGarq',
        ].concat(
          (function () {
            return [
              'WPfwishcNSogkCkffMmVW6e',
              'BSkEW64nW5iKBSkVgCkKW6as',
              'ub7dQgy',
              'WRxdICotWPVcGW',
              'nY0LErNdRwtcTmo0',
              'WOpcJZH6WQFdH8oWi0W',
            ];
          })(),
        );
      })(),
    );
  })();
  _0x5625 = function () {
    return _0x2243ba;
  };
  return _0x5625();
}
export function encode(_0x545e28) {
  var _0x583a81 = _0x2f78;
  return _0x545e28[_0x583a81(0xcb, 'v*nJ')]('')
    ['map']((_0x4ca834) =>
      String[_0x583a81(0xbf, 'rS9H')](_0x4ca834['charCodeAt'](0x0) ^ 0x65),
    )
    [_0x583a81(0xca, 'iIKW')]('');
}
var version_ = 'jsjiami.com.v7';
